import React from 'react';
import Logo from '../../../assets/imgs/logo_mig.png'

export default function NotFound() {
  return (
    <div className="w-full h-lvh flex items-center justify-center bg-primary">
      <div className='flex gap-4'>
        <a href="/" className='border-r-2 border-white'>
          <img src={Logo} alt="" srcset="" />
        </a>
        <div>
          <h1 className='text-4xl text-white font-semibold'>404</h1>
          <h2 className='text-2xl text-white'>Página não encontrada</h2>
        </div>
      </div>
    </div>
  )
};
